import { Fragment, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { stringToNumber } from '../../../special/numberConverter';
import { round } from '../../../special/round';

export const PositionRebate = ({ position, onCreate }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [percent, setPercent] = useState('');

  function handleSubmit() {
    const rate = stringToNumber(percent, 2);
    if (!rate || rate <= 0) return;

    const positionNetto = round(
      Number(position.price ?? 0) * Number(position.amount ?? 0),
    );

    onCreate(
      {
        type: 'percentEditable',
        name: t('Allowance'),
        price: positionNetto,
        amount: (rate / 100) * -1,
        taxRate: position.taxRate ?? 0,
      },
      false,
      position,
    );

    setOpen(false);
    setPercent('');
  }

  return (
    <Fragment>
      <Button
        color="secondary"
        variant="contained"
        onClick={() => setOpen(true)}
      >
        {t('Allowance')}
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{t('Allowance')}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label={t('Allowance')}
            value={percent}
            onChange={(e) => setPercent(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSubmit();
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            sx={{ mt: 1 }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>{t('Cancel')}</Button>
          <Button onClick={handleSubmit} variant="contained" color="secondary">
            {t('Apply')}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};
